import styled from 'styled-components';
import { Screen } from '../../../theme';

export const Root = styled.div`
  margin: auto;
  display: flex;
  flex-direction: column;
  padding: ${(p) => p.theme.spacing.xs};
`;

export const ButtonContainer = styled.div<{ breaks?: Screen }>`
  border-top: 1px solid ${(p) => p.theme.colors.border.main};
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding-top: ${(p) => p.theme.spacing.sm};
  gap: ${(p) => p.theme.spacing.xs};
  ${(p) => {
    if (p.breaks) {
      const screenSize = p.theme.screen[p.breaks];
      const cssRule = `  @media (max-width: ${screenSize}) {
        flex-direction: column;
      };`;
      return cssRule;
    }
  }}
`;

export const Title = styled.div`
  margin: 0 ${(p) => p.theme.spacing.sm} ${(p) => p.theme.spacing.sm};
  font-size: ${(p) => p.theme.font.size.lg};
`;
